import React from "react";
import { Row, Col } from "reactstrap";
import PropTypes from "prop-types";

import AboutThisCall from "./AboutThisCall";
import CallerData from "./CallerData";
import MarketingData from "./MarketingData";
import CampaignData from "./CampaignData";
import SignalsData from "./SignalsData";
import ConversionData from "./ConversionData";
import CallRecordingDetails from "./CallRecordingDetails";
import { dataPaneHeader } from "calls/styles/CallDetails.module.scss";

const CallDataPane = ({ call, organization, showHeader }) => {
  const { businessObjects, strings, urls } = call.customerData || {
    businessObjects: [],
    strings: [],
    urls: []
  };

  const hasCustomerData = !!(
    businessObjects.length ||
    strings.length ||
    urls.length
  );

  return (
    <>
      {showHeader && <header className={dataPaneHeader}>Call Details</header>}
      <Row>
        <Col lg={6} className="mb-4">
          <AboutThisCall cuid={call.id} {...call} />
        </Col>

        <Col lg={6} className="mb-4">
          <CallerData {...call.caller} ecp={call.ecp} />
        </Col>

        {call.evaluatedSignals && (
          <Col lg={6} className="mb-4">
            <SignalsData evaluatedSignals={call.evaluatedSignals} />
          </Col>
        )}

        {hasCustomerData && (
          <Col lg={6} className="mb-4">
            <MarketingData {...call.customerData} />
          </Col>
        )}

        <Col lg={6} className="mb-4">
          <CampaignData {...organization} {...call} />
        </Col>

        <Col lg={6} className="mb-4">
          <ConversionData {...organization} {...call.conversionData} reportMetadata={call.reportMetadata} />
        </Col>

        {call.conditionDetail && (
          <Col lg={6} className="mb-4">
            <CallRecordingDetails {...call.conditionDetail} />
          </Col>
        )}
      </Row>
    </>
  );
};

CallDataPane.propTypes = {
  call: PropTypes.object.isRequired,
  organization: PropTypes.object.isRequired,
  showHeader: PropTypes.bool
};

CallDataPane.defaultProps = {
  showHeader: false
};

export default CallDataPane;
